import React,{useEffect,useReducer,useRef} from 'react';
import {useTune} from './state.jsx';
import {artworkFor,artworkReducer,resolveStationIcon,serverIconPath} from './artwork.js';
import QualityBadge from './QualityBadge.jsx';
import {useStationTint} from './artwork-color.js';

export function StationArtworkImage({station,adapt=true,className='',eager=false,compact=true}){
  const [{attempt,loaded,source},dispatch]=useReducer(artworkReducer,{attempt:0,loaded:false,source:null});
  const root=useRef(null);
  const {favicon,fallback,mode}=artworkFor(station,{failed:attempt>0,source,adapt}),useFavicon=Boolean(favicon);
  const fail=()=>dispatch({type:'error',attempt});
  // "Station artwork" on: the backdrop takes on the icon's dominant color once the icon is shown.
  const tint=useStationTint(station,{enabled:adapt&&useFavicon,ready:loaded});
  useEffect(()=>{
    if(attempt!==0||!station?.favicon||!serverIconPath(station))return;
    const controller=new AbortController();let active=true;
    const load=()=>resolveStationIcon(station,{signal:controller.signal}).then(url=>{if(active)dispatch(url?{type:'resolved',attempt,source:url}:{type:'error',attempt});}).catch(()=>{if(active)dispatch({type:'error',attempt});});
    let observer;
    if(eager||typeof IntersectionObserver==='undefined')void load();
    else{
      observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();void load();}},{rootMargin:'200px'});
      observer.observe(root.current);
    }
    return()=>{active=false;observer?.disconnect();controller.abort();};
  },[attempt,eager,station?.stationuuid,station?.favicon]);
  return <div ref={root} className={`station-artwork ${className}`} data-artwork={mode}>
    <img src={fallback} alt="" aria-hidden="true" loading={eager?'eager':'lazy'} className={`absolute inset-0 h-full w-full bg-slate object-contain p-[12%] transition-opacity ${useFavicon&&loaded?'opacity-0':'opacity-100'}`}/>
    {useFavicon&&<>
      <div className={`absolute inset-0 bg-slate transition-opacity ${loaded?'opacity-100':'opacity-0'}`}>
        {adapt&&<>
          <img key={`backdrop:${favicon}`} src={favicon} alt="" aria-hidden="true" loading={eager?'eager':'lazy'} referrerPolicy="no-referrer" className="absolute inset-0 h-full w-full scale-150 object-cover opacity-40 blur-2xl"/>
          <div className="absolute inset-0 bg-gradient-to-br from-midnight/45 via-slate/60 to-midnight/85"/>
          <div aria-hidden="true" className="absolute inset-0 transition-opacity duration-500" style={{opacity:tint?1:0,...(tint&&{background:`linear-gradient(135deg,${tint.backdrop},${tint.surface})`})}}/>
          <div className="absolute -right-1/4 -bottom-1/2 h-full w-full rounded-full border border-mint/15 bg-mint/5"/>
        </>}
      </div>
      <img key={favicon} src={favicon} alt="" aria-hidden="true" loading={eager?'eager':'lazy'} decoding="async" referrerPolicy="no-referrer" onLoad={event=>{if(event.currentTarget.naturalWidth)dispatch({type:'loaded',attempt});else fail();}} onError={fail} className={`absolute left-1/2 top-1/2 h-[64%] w-[64%] -translate-x-1/2 -translate-y-1/2 object-contain transition-opacity ${loaded?'opacity-100':'opacity-0'} ${adapt?'drop-shadow-[0_4px_12px_#0B102080]':''}`}/>
    </>}
    <QualityBadge station={station} compact={compact}/>
  </div>;
}
export default function StationArtwork(props){
  const {settings}=useTune();
  return <StationArtworkImage key={`${props.station?.stationuuid}:${props.station?.favicon||''}`} adapt={settings.adaptStationArtwork!==false} {...props}/>;
}
